import { t } from "@hakili/i18n";

import { asSentence } from "../sentence.js";

/**
 * `ARC2-BAY` (D2 `ui.js` INC, AA-AD ruling): the typed cause of an incomplete note, bound to D2's short form and sentence. `null` for a cause the
 * designer has not drawn (`tauxMandat`, `inconnue`): the server's words print there.
 */
export function incompleteCauseOf(
  incomplete: { readonly cause: string; readonly words?: string } | null,
): { readonly court: string; readonly phrase: string } | null {
  if (incomplete === null) return null;
  switch (incomplete.cause) {
    case "grille":
      return { court: t("bank.hakili.causeGrilleCourt"), phrase: t("bank.hakili.causeGrillePhrase") };
    case "quotiteCessible":
      return {
        court: t("bank.hakili.causeQuotiteCessibleCourt"),
        phrase: t("bank.hakili.causeQuotiteCessiblePhrase"),
      };
    case "revenuNet":
      return {
        court: t("bank.hakili.causeRevenuNetCourt"),
        phrase: t("bank.hakili.causeRevenuNetPhrase"),
      };
    case "engagements":
      return {
        court: t("bank.hakili.causeEngagementsCourt"),
        phrase: t("bank.hakili.causeEngagementsPhrase"),
      };
    // D2 frames 137, 138: the short form is D2's; the sentence is the contract's own words where the server gave one.
    case "tauxMandat":
      return {
        court: t("bank.hakili.causeTauxMandatCourt"),
        phrase: sentenceOr(incomplete.words, t("bank.hakili.causeTauxMandatPhrase")),
      };
    case "inconnue":
      return {
        court: t("bank.hakili.causeInconnueCourt"),
        phrase: sentenceOr(incomplete.words, t("bank.hakili.causeInconnuePhrase")),
      };
    default:
      return null;
  }
}

const sentenceOr = (words: string | undefined, fallback: string): string =>
  words === undefined || words.trim() === "" ? fallback : asSentence(words);
